/**
 * dead simple loader
 *
 * wait for the platform to be ready
 * then remove itself
 * TODO : add animation ^^
 */
import type { OnInit, Signal } from '@angular/core';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    computed,
    DestroyRef,
    effect,
    inject,
    signal,
    untracked,
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { map, of } from 'rxjs';

import { Maybe,SpinnerComponent } from '@evc/web-components';

import { activatedRoute$ } from '../../features/utilities/router.utils';
import { PlatformService } from '../../platform.service';
import { LoaderService } from './loader.service';

@Component({
  selector: 'evc-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SpinnerComponent],
})
export class LoaderComponent implements OnInit {
  #platformService = inject(PlatformService);
  #loadingService = inject(LoaderService);
  #changeDetectorRef = inject(ChangeDetectorRef);

  #destroyRef = inject(DestroyRef);
  #router = inject(Router, { optional: true });

  isLoading = toSignal(this.#loadingService.loading$);
  showSpinner = signal(false);
  #animationDone = signal(false);
  loaded: Signal<Maybe<true>> = this.#platformService.initialized;

  showLoader = computed(() => !this.loaded() || !this.#animationDone());

  #triggerFadeOut = effect(() => {
    if (!this.loaded()) return;
    untracked(() => {
      this.#fadeOut();
    });
  });

  ngOnInit(): void {
    this.#destroyRef.onDestroy(() => {
      this.#triggerFadeOut.destroy();
    });

    const waitActivatedRoute$ = this.#router
      ? activatedRoute$(this.#router).pipe(
          takeUntilDestroyed(this.#destroyRef),
          map(() => true),
        )
      : of(true);

    waitActivatedRoute$.subscribe((activated) => {
      this.showSpinner.set(activated);
    });
  }
  #fadeOut() {
    setTimeout(() => {
      this.#animationDone.set(true);
      this.#changeDetectorRef.detectChanges();
    }, 250);
  }
}
